// A modification's schedule_rule conflict as before → after rule cards:
// deliverable, the rule in words, and the source quote (SAD-901). Shared by
// the single-item panel and the grouped same-value drawer.
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraButton, SpecraKeyValueRow, SpecraSurface, SpecraText } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { sourceHasLocation } from '../../lib/sourceOpen';
import { scheduleRuleWords } from './reviewItemCopy';
export function isScheduleRuleConflict(review) {
    if (review.targetFieldPath.trim() !== 'schedule_rule') return false;
    const keys = new Set(review.candidates.map((c)=>c.key));
    return keys.has('on_file') && keys.has('modification');
}
export function ScheduleRuleCards({ review, deliverable, fallbackDocId = '', canOpen = false, onOpen }) {
    const onFile = review.candidates.find((c)=>c.key === 'on_file');
    const mod = review.candidates.find((c)=>c.key === 'modification');
    const card = (side, c, heading)=>{
        const words = c ? scheduleRuleWords(c) : '—';
        const quote = c?.sources.map((s)=>s.quote.trim()).find(Boolean) || '';
        const source = c?.sources[0];
        return /*#__PURE__*/ _jsxs(SpecraSurface, {
            radius: "md",
            className: "p-3",
            "data-testid": Testids.reviewItem.ruleCard,
            "data-side": side,
            children: [
                /*#__PURE__*/ _jsx(SpecraText, {
                    as: "p",
                    size: "meta",
                    tone: "muted",
                    className: "uppercase tracking-wide",
                    children: heading
                }),
                deliverable && /*#__PURE__*/ _jsx(SpecraKeyValueRow, {
                    label: "Deliverable",
                    value: deliverable,
                    className: "mt-2"
                }),
                /*#__PURE__*/ _jsx(SpecraKeyValueRow, {
                    label: "Rule",
                    value: words
                }),
                quote && /*#__PURE__*/ _jsxs("blockquote", {
                    className: "mt-2 whitespace-pre-line border-l-2 border-border pl-2 text-[length:var(--fs-ui-body)] italic text-muted-foreground",
                    children: [
                        "“",
                        quote,
                        "”"
                    ]
                }),
                source && canOpen && onOpen && (source.artifactId || fallbackDocId) && sourceHasLocation(source) && /*#__PURE__*/ _jsx("div", {
                    className: "mt-1.5",
                    children: /*#__PURE__*/ _jsx(SpecraButton, {
                        variant: "secondary",
                        size: "sm",
                        onClick: ()=>onOpen(source),
                        "data-testid": Testids.reviewItem.sourceOpen,
                        children: source.page > 0 ? `Open page ${source.page}` : 'Open document'
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: "mt-2 space-y-2",
        "data-testid": Testids.reviewItem.ruleCards,
        children: [
            card('before', onFile, 'On file'),
            card('after', mod, 'Modification')
        ]
    });
}
